import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { Checkbox, Grid, Button, Box } from "@material-ui/core";
import useStyles from "./styles";

const CheckBox = ({ item, toggleTransporter, selectedId, ...props }) => {
  const [checked, setChecked] = useState(false);
  const classes = useStyles();


  const isSelected = useMemo(()=>{
    if(selectedId){
     if(selectedId.includes(item.id)){ 
        return true 
      }else{ 
        return false
      }
    }else{
      return item.accessibleToUser
    }
  },[selectedId, item.id, item.accessibleToUser]);

   useEffect(() => {
    setChecked(isSelected)
  }, [isSelected]);

  const { checkedB, label, box, ...rippleClasses } = classes;
  return (
    <Box
      border={2}
      className={classes.box}
      style={{ borderColor: checked && "#ABAD23" }}
      {...props}
    >
      <Button
        className={classes.button}
        TouchRippleProps={{ classes: rippleClasses }}
        onClick={() => {
          toggleTransporter({ id: item.id });
          setChecked(!checked);
        }}
      >
        <Checkbox
          checked={checked}
          className={classes.checkedB}
          onChange={() => {
            toggleTransporter({ id: item.id });
            setChecked(!checked);
          }}
          name="checkedA"
          color="primary"
        />
        <Grid container direction="row">
          <Grid item xs={12}>
            <h4>
              Address: {item.external_id}, Razão Social: {item.name}
            </h4>
          </Grid>
        </Grid>
      </Button>
    </Box>
  );
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  toggleTransporter: (payload) =>
    dispatch.users.toggleTransporterAsync(payload),
});
export default connect(mapState, mapDispatch)(CheckBox);
